import classNames from 'classnames/bind';

import { useFile } from 'files/hooks/useFile';

import styles from './VideoSourceROI.module.scss';

const c = classNames.bind(styles);

type VideoSourceROIPreviewProps = {
  fileId: string | undefined | null;
};

export function VideoSourceROIPreview({ fileId }: VideoSourceROIPreviewProps) {
  const { data: file, isLoading: isLoadingFile } = useFile(fileId);

  const isLoading =
    isLoadingFile || (file && file.cloud_status === 'uploading');

  if (!fileId || !file || !file.data_url) {
    return <div className={c('placeholder')} />;
  }

  if (isLoading) {
    return (
      <>
        <div className="loading-spinner-wrap">
          <span className="loading-spinner small" />
        </div>
        <div className={c('placeholder')} />
      </>
    );
  }

  return (
    <img
      className={c('image')}
      src={file.data_url}
      alt={`${file.name} snapshot`}
    />
  );
}
